export default "__VITE_ASSET__154839a9__"